import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "../home/home.css";
import "./submission.css";
class Submission extends Component {
	render() {
		return (
			<>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">CALL FOR PAPERS</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi">
						Instructions For Authors
					</p>
					<h5>
						The manuscript should be prepared following the guidelines of
						Springer Conference Proceedings
						<a href="https://www.springer.com/gp/authors-editors/conference-proceedings/conference-proceedings-guidelines">
							(https://www.springer.com/gp/authors-editors/conference-proceedings/conference-proceedings-guidelines).
						</a>
						The manuscripts should be submitted in PDF format.{" "}
					</h5>
				</div>
				<div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi1">
						Submission Closed
					</p>
					
				</div>
				{/* <div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi">Paper Submission</p>
					<h5>
						Submission should be done through EasyChair Conference management
						portal using the link
						<a href="https://easychair.org/conferences/?conf=icishmc2022">
							https://easychair.org/conferences/?conf=icishmc2022.
						</a>
					</h5>
				</div> */}
			</>
		);
	}
}

export default Submission;
